import type { CartState } from '@eventflow/shared-types';
import { configureStore } from '@reduxjs/toolkit';
import authReducer, { type AuthState } from '../features/auth/authSlice';
import cartReducer from '../features/checkout/cartSlice';
import mapEditorReducer, { type MapEditorState } from '../features/map-editor/mapEditorSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    mapEditor: mapEditorReducer,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar acciones de auth que pueden contener funciones
        ignoredActions: ['auth/setUser'],
      },
    }),
});

// Definir RootState explícitamente para evitar problemas de inferencia
export interface RootState {
  auth: AuthState;
  mapEditor: MapEditorState;
  cart: CartState;
}

export type AppDispatch = typeof store.dispatch;
